<template>
    <section class="tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-shadow-sm tw-mb-4 tw-px-5 tw-pb-5">
        <div class="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-gray-100 tw-bg-gray-50 tw--mx-5 tw-px-5 tw-h-10 tw-mb-4 tw-rounded-t-lg">
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-uppercase tw-text-gray-700">
                <span class="tw-inline-block tw-w-2 tw-h-2 tw-rounded-full tw-bg-blue-600"></span>
                {{ $t("assignDriver.targetRouteDriverSetup") }}
            </div>
            <div class="tw-text-xs tw-text-gray-400">
                {{ $t("assignDriver.requiredFieldsHint") }} <span class="tw-text-red-500 tw-font-bold">*</span>
            </div>
        </div>

        <div>
            <label class="required tw-block tw-text-xs tw-font-bold tw-text-gray-600 tw-mb-2">
                {{ $t("assignDriver.targetRouteDriver") }}
            </label>
            <a-select
                show-search
                :value="driverId"
                class="tw-w-full"
                :default-active-first-option="false"
                :filter-option="false"
                :not-found-content="null"
                :placeholder="$t('assignDriver.selectTargetRouteDriver')"
                @change="$emit('change-driver', $event)"
                @search="$emit('search-driver', $event)"
            >
                <a-select-option
                    v-for="driver in driverList"
                    :key="driver.driver_id"
                    :value="driver.driver_id"
                >
                    {{ driver.driver_name }}
                </a-select-option>
            </a-select>
            <div class="tw-text-red-500 tw-text-xs tw-mt-2" v-if="errors.has('driver_id')">
                {{ errors.first("driver_id") }}
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "DriverSetupSection",
    props: {
        driverId: {
            default: null
        },
        driverList: {
            type: Array,
            default: () => []
        },
        errors: {
            required: true
        }
    }
};
</script>
